import { FilterModel, SearchProductWithSkusModel, UnifiedSearchResultModel } from '@bizzkit/ecommerce-search/client';
import { InstalledEquipment } from '@/api/appSolutionBuilder/types';
import { AppSolutionBuilderSearchResult } from '@/api/product/types';
import { FilterType } from '@/api/product/types';
import { SearchSettingsResponse } from '@/generated/data.schemas';
import { mapFacets, mapProductItem, mapInstalledEquipment } from '../product/mapping';

export const mapSearchResult = (
	data: UnifiedSearchResultModel | undefined,
	settings: SearchSettingsResponse | undefined,
): AppSolutionBuilderSearchResult | undefined => {
	if (!data) {
		return undefined;
	}

	return {
		products: data.products?.map((p) => mapProductItem(p, settings)) || [],
		filters: mapFacets(data.facets, settings) || [],
	};
};

export const mapInstalledEquipmentsResult = (products: SearchProductWithSkusModel[]): InstalledEquipment[] => {
	return (
		products
			?.map((p) => {
				return mapInstalledEquipment(p) || [];
			})
			?.flat() || []
	);
};

export const mapSearchFilters = (specificationFilters) => {
	const filters: Record<string, FilterModel> = {};

	specificationFilters?.forEach((f) => {
		if (f.type === FilterType.Number) {
			if (filters[f.id] !== undefined) {
				filters[f.id].from = f.min;
				filters[f.id].to = f.max;
			} else {
				filters[f.id] = { from: f.min, to: f.max };
			}
		} else if (f.type === FilterType.String) {
			if (!f.values?.length) return;
			if (filters[f.id] !== undefined) {
				f.values.forEach((v) => filters[f.id].values?.push(v.value));
			} else {
				filters[f.id] = { values: f.values.map((v) => v.value) };
			}
		}
	});
	return filters;
};
